import Footer from "common/footer";
import Header from "common/header/header";
import TextBanner from "common/textBanner";
import React, { useEffect } from "react";
import CheckoutForm from "./layouts/checkoutForm";

const Checkout = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <TextBanner text="Checkout" />
      <CheckoutForm />
      <Footer />
    </>
  );
};

export default Checkout;
